import db from "@/plugins/dexie";
import moment from "moment-timezone";

export default {
  namespaced: true,

  state: {
    list: [],
    cache_produto: [],
    cache_grupo: [],
    cache_prevenda: [],
    arrayDataAtualizacao: [],
    primeiroUpdate: false,
  },

  getters: {
    list: (state) => state.list,
    arraydata: (state) => {
      return state.arrayDataAtualizacao;
    },
    primeiroUpdate: (state) => {
      return state.primeiroUpdate;
    },
    cacheProduto: (state) => state.cache_produto,
    cacheGrupo: (state) => state.cache_grupo,
    cachePrevenda: (state) => state.cache_prevenda,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {

    async esvaziarCache({ commit }, payload) {
      if(payload.att){
        const dataatt = (await db[payload.tabela].orderBy(`${payload.att}`).filter(item => item[payload.att] !== null).last())[payload.att];
        commit('SET_ATUALIZA_DATA', {tabela: payload.tabela, data: moment.utc(dataatt).format('YYYY-MM-DD HH:mm:ss.SSS')})
      }
      commit('EMPTY_CACHE', payload.tabela);
    },

    async setCache({ commit }, payload) {
      commit('SET_CACHE', payload);
    },

    async pushCache({ commit, state }, payload) {
      if (state[`cache_${payload.tabela}`].length > 0) {
        commit('PUSH_CACHE', payload);
      }
    },

    async getCache({ state }, tabela){
     return state[`cache_${tabela}`].length
    },

    async atualizaData({ commit }, atualizar) {
      commit('SET_ATUALIZA_DATA', atualizar);
    },

    async primeiroUpdate({ commit }, estado) {
      commit('SET_PRIMEIRO_UPDATE', estado);
    },

    async reloadCache({ commit} , tabela) {
      const dados = await db[tabela].toArray();
      commit('SET_CACHE', {tabela, dados});
    }
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    EMPTY_CACHE(state, tabela) {
      state[`cache_${tabela}`] = [];
    },
    SET_CACHE(state, payload) {
      state[`cache_${payload.tabela}`] = payload.dados ?? [];
    },
    PUSH_CACHE(state, payload) {
      state[`cache_${payload.tabela}`].push(...payload.novosItens);
    },
    SET_CACHE_ARRAYDATA(state, arraydata) {
      state.arrayDataAtualizacao = arraydata ?? [];
    },
    SET_ATUALIZA_DATA(state, atualizar) {
      state.arrayDataAtualizacao.map((item, index) => {
        if (item.tabelaApp === atualizar.tabela) {
          state.arrayDataAtualizacao[index].data = atualizar.data;
        }
      })
    },
    SET_PRIMEIRO_UPDATE(state, estado) {
      state.primeiroUpdate = estado ?? false;
    }
  },
};
